import { QueryKey } from '@tanstack/react-query';

const baseKey: QueryKey = ['home'] as const;

export const homeQuery = {
  base: baseKey,
  getConferences: [...baseKey, 'get-conferences'],
  getNotifications: [...baseKey, 'get-notifications'],
  getRecentWork: [...baseKey, 'get-recent-work'],
} as const;
